import { render } from "./mvt-nearby.vue?vue&type=template&id=b4fa5cce"
import script from "./mvt-nearby.js?vue&type=script&lang=js"
export * from "./mvt-nearby.js?vue&type=script&lang=js"

import "./mvt-nearby.vue?vue&type=style&index=0&id=b4fa5cce&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__